import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

const StatCard = ({ label, value, color = "text.primary", onClick }) => (
  <Card
    variant="outlined"
    sx={{
      borderRadius: 2,
      borderColor: "divider",
      minWidth: 160,
      cursor: onClick ? "pointer" : "default",
    }}
    onClick={onClick}
  >
    <CardContent sx={{ "&:last-child": { pb: 2 } }}>
      <Typography
        variant="caption"
        color="text.secondary"
        fontWeight={600}
        textTransform="uppercase"
        letterSpacing={0.5}
      >
        {label}
      </Typography>
      <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5, color }}>
        {value}
      </Typography>
    </CardContent>
  </Card>
);

/** Delivered, awaiting and final-rejected totals; Awaiting toggles the pending filter. */
const DeliveryStatCards = ({
  deliveredTotal,
  pendingTotal,
  rejectedTotal,
  onToggleAwaiting,
}) => (
  <Box display="flex" flexWrap="wrap" gap={2} mb={3}>
    <StatCard label="Total delivered" value={deliveredTotal} />
    <StatCard
      label="Awaiting delivery"
      value={pendingTotal}
      color="#b45309"
      onClick={onToggleAwaiting}
    />
    <StatCard label="Rejected" value={rejectedTotal} color="#b45309" />
  </Box>
);

export default DeliveryStatCards;
